import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { usePermission } from '@contexts/Auth/UsePermission';

import List from './components/List';
import Page403 from '@page/Common/403/403';
const OriginalData = () => {
  const { originalData } = usePermission();

  // Nếu không có quyền view, hiển thị trang 403
  if (!originalData.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb homePath={'/dashboard'} routeSegments={[{ name: 'Dữ liệu gốc' }]} />
      </div>
      <List />
    </ContainerBody>
  );
};
export default compose(withPaginate)(OriginalData);
